import React, {useEffect, useState} from 'react';
import {useStore} from '@app/state/store';
import {FilterButton} from '@app/tools/filter/ui/filter-button';
import {FilterControls} from '@app/tools/filter/ui/filter-controls';
import {
  ScrollableView,
  ScrollableViewItem,
} from '@app/ui/navbar/scrollable-view';
import {state, tools} from '@app/state/utils';
import {Trans} from '@common/i18n/trans';
import {filterNameMessages} from '@app/tools/filter/filter-list';

type FilterNavProps = {
  onClose?: () => void;
  onApply?: () => void;
};

export function FilterNav({onClose, onApply}: FilterNavProps = {}) {
  const filters = useStore(s => s.config.tools?.filter?.items) || [];
  const [showFilterOptions, setShowFilterOptions] = useState(false);
  const [activeFilter, setActiveFilter] = useState<string | null>(null);

  useEffect(() => {
    tools().filter.syncState();
  }, []);

  // Handle navbar close/apply buttons
  const handleNavbarClose = () => {
    if (showFilterOptions) {
      // Filter options menüsünden ana filter listesine dön
      setShowFilterOptions(false);
      setActiveFilter(null);
    } else {
      // Ana filter listesinden filter tool'dan çık
      if (onClose) {
        onClose();
      } else {
        state().cancelChanges();
      }
    }
  };

  const handleNavbarApply = () => {
    if (showFilterOptions) {
      // Filter options menüsünden ana filter listesine dön
      setShowFilterOptions(false);
      setActiveFilter(null);
    } else {
      // Ana filter listesinden tool'dan çık
      if (onApply) {
        onApply();
      } else {
        state().applyChanges();
      }
    }
  };

  // Expose handlers to parent
  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      (window as any).filterNavHandlers = {
        close: handleNavbarClose,
        apply: handleNavbarApply,
        isInOptionsMenu: showFilterOptions
      };
    }
  }, [showFilterOptions, onClose, onApply]);

  const openFilterOptions = (filter: string) => {
    setActiveFilter(filter);
    setShowFilterOptions(true);
    // Select the filter for options
    state().filter.select(filter, tools().filter.hasOptions(filter));
  };

  if (showFilterOptions && activeFilter) {
    return (
      <FilterOptionsMenu
        filter={activeFilter}
      />
    );
  }

  const filterBtns = filters.map((filter: any) => (
    <ScrollableViewItem key={filter}>
      <FilterButton
        filter={filter}
        onOptionsClick={() => openFilterOptions(filter)}
      />
    </ScrollableViewItem>
  ));
  return <ScrollableView>{filterBtns}</ScrollableView>;
}

type FilterOptionsMenuProps = {
  filter: string;
};

function FilterOptionsMenu({filter}: FilterOptionsMenuProps) {
  const msg = filterNameMessages[filter];

  return (
    <div className="h-full flex flex-col min-w-320">
      {/* Header sadece filter adı ile */}
      <div className="flex justify-center items-center p-4 border-b border-divider">
        <div className="text-sm font-medium capitalize">
          {msg ? <Trans {...msg} /> : filter}
        </div>
      </div>

      {/* Filter controls */}
      <div className="flex-1 overflow-auto">
        <FilterControls />
      </div>
    </div>
  );
}
